import { NgModule } from "@angular/core";
import { GetControlPipe } from "./get-control.pipe";
import { GetValuePipe } from "./get-value.pipe";

@NgModule({
  declarations: [GetControlPipe, GetValuePipe],
  exports: [GetControlPipe, GetValuePipe],
})
export class GetControlModule {}
